import { add as _add, getList as _getList, update as _update, getOneById as _getOneById, deleteAll as _deleteAll } from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/invoicing/invoices";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "consecutive",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 10,
};

function normalizeInvoiceData(data) {
    const {
        issueDate: issueDateInMillis,
        paymentDueDate: paymentDueDateInMillis,
        stampCreationDatetime: stampCreationDatetimeInMillis,
        stampModificationDatetime: stampModificationDatetimeInMillis,
    } = data;

    const issueDate = new Date(issueDateInMillis);
    const paymentDueDate = new Date(paymentDueDateInMillis);
    const stampCreationDatetime = new Date(stampCreationDatetimeInMillis);
    const stampModificationDatetime = new Date(stampModificationDatetimeInMillis);

    return {
        ...data,
        issueDate,
        issueDateString: dateToString(issueDate),
        paymentDueDate,
        stampCreationDatetime,
        stampModificationDatetime,
    };
}

function normalizeData(data) {
    return data.map(normalizeInvoiceData);
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function addForAccounting({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizeInvoiceData,
    });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}
